import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "快速导航",
    links: [
      { label: "首页", path: "/" },
      { label: "分类浏览", path: "/category" },
      { label: "关于我们", path: "/about" },
      { label: "注册指南", path: "/category" },
    ],
  },
  {
    title: "帮助支持",
    links: [
      { label: "常见问题", path: "/category" },
      { label: "安全指南", path: "/category" },
      { label: "用户协议", path: "/about" },
      { label: "隐私政策", path: "/about" },
    ],
  },
  {
    title: "关注我们",
    links: [
      { label: "微信公众号", path: "#" },
      { label: "新浪微博", path: "#" },
      { label: "官方App下载", path: "#" },
      { label: "联系客服", path: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="container-page py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <span
              className="text-3xl font-bold"
              style={{ fontFamily: "'Dancing Script', cursive" }}
            >
              爱情岛
            </span>
            <p className="mt-4 text-sm text-background-400 leading-relaxed max-w-sm">
              爱情岛网站是领先的在线交友与娱乐平台，致力于为用户打造安全、便捷、高效的交友环境。
              我们以技术创新为驱动，以用户满意为目标，用心连接每一份美好缘分。
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    {link.path.startsWith("/") ? (
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.path}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                        rel="nofollow"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 爱情岛网站 版权所有 | 用心连接每一份美好缘分
          </p>
          <p className="text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">ICP备案号：京ICP备2024XXXXXXXX号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}